// ModalButtons.jsx

import React from 'react';

// CSS
import './ModalButtons.css';

/**
 * ModalButtons Component
 * 
 * This component renders a section container for modal buttons.
 * 
 * @param {JSX.Element} children - The children to render.
 * 
 * @returns {ReactNode} The rendered component.
 */
const ModalButtons = ({ style = {}, children }) => {

  return (
    <>
      {/* BUTTONS */}
      <div className="modal-buttons-container"
        style={{
          ...style,
        }}>
        {children}
      </div>
    </>
  );
};

export default ModalButtons;
